var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWildArrow = function SvgWildArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.198.293 8.635 8.298.001-.001 2.698 2.593L17.2 22.073l-2.698-2.594 6.688-6.426H0V9.386h21.265l-6.765-6.5L17.198.293Z",
    fill: "currentColor"
  })));
};
export { SvgWildArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjkgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjE5ODIgMC4yOTI5NjlMMjUuODMzMyA4LjU5MDY3TDI1LjgzNDEgOC41ODk5NkwyOC41MzIzIDExLjE4MjdMMTcuMTk5OSAyMi4wNzIxTDE0LjUwMTggMTkuNDc5NEwyMS4xOSAxMy4wNTI1SDBWOS4zODU4N0gyMS4yNjQ1TDE0LjUgMi44ODU2OUwxNy4xOTgyIDAuMjkyOTY5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";